import React from 'react';
import styled from 'styled-components';

interface Props {
  children?: React.ReactNode;
}
const Tabs: React.FC<Props> = ({ children }) => {
  return <StyledTabs>{children}</StyledTabs>;
};

const StyledTabs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
`;

export default Tabs;
